import { T as TimeFormat } from './TimeFormat-a7f5565b.js';

const formatMobileDate = (value, format, locale) => {
  return value.toLocaleString(locale, {
    dateStyle: 'medium',
    timeZone: 'UTC'
  });
};

const formatMobileTime = (value, format, locale) => {
  return value.toLocaleString(locale, {
    timeStyle: 'short',
    hourCycle: typeof format !== 'function' && format !== TimeFormat.Auto ? format : undefined,
    timeZone: 'UTC'
  });
};

const getCurrentDate = () => {
  const currentDate = new Date();
  return new Date(Date.UTC(currentDate.getUTCFullYear(), currentDate.getUTCMonth(), currentDate.getUTCDate()));
};

export { formatMobileTime as a, formatMobileDate as f, getCurrentDate as g };
